// extracted by mini-css-extract-plugin
export default {"spaced":"styles_spaced__zuH9j","text":"styles_text__i34op","contain":"styles_contain__7E+1S","icon":"styles_icon__CghHo"};